import { WorkspaceSubscriptionStatus } from '@easy-expense/data-schema-v2';

/**
 * True only when a fellow member's own subscription covers this workspace (the
 * getWorkspaceSubscriptionStatus fallback path) — never when covered by this workspace's own
 * Organization (coveringUserID is null in that case), and never true for the covering member
 * themselves viewing their own billing (specs/004-client-subscription-integration FR-003).
 */
export function computeIsCoveredByTeammate(
  status: WorkspaceSubscriptionStatus | null,
  currentUserID: string | undefined,
): boolean {
  return (
    status?.active === true &&
    status.coveringUserID !== null &&
    status.coveringUserID !== currentUserID
  );
}
